import i18n from '@/setup/i18n.js';
import { showCDCScreenSet, showErrorNotification } from '@/plugins/cdc/shared.js';

export const SCREEN_SET_NAME = 'General-ProfileUpdate';

const START_SCREEN_MAP = {
  licenseNumber: 'gigya-screen-licence-number',
};

/**
 * Triggers the input overlay to enter the license number.
 *
 * @returns {Promise}
 */
export function onEnterCustomerLicenseNumber() {
  return new Promise((resolve, reject) => {
    if (window.gigya?.accounts) {
      window.gigya.thisScript.globalConf.onLicenseNumberUpdated = (licenseNumber) => {
        resolve(licenseNumber);
      };

      showCDCScreenSet({
        screenSet: SCREEN_SET_NAME,
        startScreen: START_SCREEN_MAP.licenseNumber,
      });
    } else {
      showErrorNotification(i18n.global.t('globalMessages.loginUnavailable'));

      reject(new Error('CDC Profile: not logged in.'));
    }
  });
}

/**
 * Define the plugin structure.
 */
export const cdcProfilePlugin = {
  onEnterCustomerLicenseNumber,
};
